var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tab',{attrs:{"name":"labels","label-key":"generic.labelsAndAnnotations"}},[_c('Labels',{attrs:{"mode":_vm.mode,"display-side-by-side":false},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }